import React, {Component} from "react";
import {Redirect} from "react-router-dom";
import Cookies from "universal-cookie";

import Header from "../../Containers/Header/Header";
import Footer from "../../Containers/Footer";
import BaseBtn from "../../Buttons/BaseBtn";
import PopupRegisterForm from "../../Containers/PopupRegisterForm";
import PopupFindForm from "../../Containers/PopupFindForm";
import PopupAlert from "../../Containers/PopupAlert";

import * as UserService from "../../../services/User/UserService";
import * as Utils from "../../Utils";
import Loading from "../../Containers/Loading";

class Login extends Component {
    state = {
        requestID: '',
        requestPW: '',
        login: false,
        loginFail: false,
        signUp: false,
        findData: false,
        serverError: false,
        isFindData: '',
        link: "/app/homework",
        // loading
        isLoadingHide: false
    };

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    };

    onSignUp = () => {
        this.setState({
            signUp: true
        });
    }

    onSubmit = () => {
        if (Utils.isConnectedLocalServer()) {
            this.loginToLocal();
        } else {
            this.loginToServer();
        }
    }

    onFindData = (e, data) => {
        e.preventDefault();

        this.setState({
            findData: true
        });

        if (data === 'id') {
            this.setState({
                isFindData: 'id'
            });
        } else {
            this.setState({
                isFindData: 'pw'
            });
        }
    }

    onKeyupEnterKey = (event) => {
        if (event.keyCode == 13) {
            this.onSubmit();
        }
    }

    loginToLocal = () => {
        this.setState({
            login: true
        });
    }

    loginToServer = () => {
        const cookies = new Cookies();
        const {requestID, requestPW} = this.state;

        if( requestID == null || requestID == undefined || requestID.trim() == '' ) {
            alert('아이디를 입력해 주세요');
            return false;
        }
        if( requestPW == null || requestPW == undefined || requestPW.trim() == '' ) {
            alert('비밀번호를 입력해 주세요');
            return false;
        }

        const that = this;
        UserService.login(requestID, requestPW).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    const expires = new Date(Date.now() + (response.data.data.data.expires_in * 1000));
                    cookies.set('beacon_token', response.data.data.data.auth, {path: '/', expires: expires});
                    this.setState({
                        login: true,
                        link: response.data.data.url
                    });
                } else if (response.data !== null && response.data.code === '0002') {
                    console.log(response.data);
                    alert(response.data.data);
                }
            } else {
                console.log(response);
                this.setState({
                    loginFail: true
                });
            }
        }).catch( function(error) {
            if( error.response.status == 401 ) {
                that.setState({
                    loginFail: true
                });
            } else {
                console.log(error.response);
                that.setState({
                    serverError: true
                });
            }
            // Local 테스트로 전환
            //Utils.setLocalServer();
            //this.loginToLocal();
        });
    }

    popupConfirm = () => {
        this.setState({
            loginFail: false,
            serverError: false,
            requestID: '',
            requestPW: '',
        });
    }

    registerPopupClose = () => {
        this.setState({
            signUp: false
        })
    }

    findPopupCancle = () => {
        this.setState({
            findData: false
        })
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        const {requestID, requestPW, login, loginFail, signUp, link, findData, isFindData, findID, serverError} = this.state;

        if (login === true) {
            return <Redirect to={link}/>
        }

        return (
            <div className="beaconWrapper">
                <Header/>
                <div className="allconWrapper" style={{background: 'url("/images/bg/bg_login.png") no-repeat center bottom'}}>
                    <div className="contentsWrapper">
                        <div className="pageContents">
                            <div className="loginBox">
                                <form name="studentLogin" className="loginForm">
                                    <fieldset>
                                        <legend className="screenOut">학생 로그인</legend>
                                        <h3>
                                            <img src="/images/common/logo_beacon_big.png" alt="Beacon Education"></img>
                                        </h3>
                                        <div className="formContents">
                                            <div className="inputWrapper">
                                              <span className="customInputBox">
                                                  <label htmlFor="requestID">
                                                      <span>아이디</span>
                                                      <input type="text" value={requestID}
                                                             onKeyUp={this.onKeyupEnterKey} onChange={this.handleChange}
                                                             name="requestID"/>
                                                  </label>
                                              </span>
                                                <span className="customInputBox">
                                                  <label htmlFor="requestPW">
                                                      <span>비밀번호</span>
                                                      <input type="password" value={requestPW}
                                                             onKeyUp={this.onKeyupEnterKey} onChange={this.handleChange}
                                                             name="requestPW"/>
                                                  </label>
                                              </span>
                                            </div>
                                            <div className="btnWrapper">
                                                <BaseBtn btnColor={"loginYellow"} btnName={"회원가입"}
                                                         onClick={this.onSignUp}/>
                                                <BaseBtn btnColor={"loginOrange"} btnName={"로그인"}
                                                         onClick={this.onSubmit}/>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                            <div className="findBox">
                                <div className="findInfoWrapper">
                                    <span><a href="#" onClick={(e) => this.onFindData(e, "id")}>아이디 찾기</a></span>
                                    <span><a href="#" onClick={(e) => this.onFindData(e, "pw")}>비밀번호 찾기</a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
                <PopupRegisterForm active={signUp} onCancel={this.registerPopupClose} onConfirm={this.registerPopupClose}/>
                <PopupAlert active={loginFail} message="아이디, 비번을 체크하세요." onConfirm={this.popupConfirm} onCancel={this.popupConfirm}/>
                <PopupAlert active={serverError} message="서버 에러 발생 했습니다. 학원에 문의해주세요." onConfirm={this.popupConfirm} onCancel={this.popupConfirm}/>
                <PopupFindForm active={findData} data={isFindData} onCancel={this.findPopupCancle}/>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Pages/Global/Login.js